import { ApiEndpointBuilder } from "@/services/api/types.ts";
import { DataResponse } from "@/types/reponse-data.ts";
import { SearchRequest } from "@/types/search-request.ts";
import { ContractProjectDetails } from "@/types/contracts";

const searchInfiniteProjectsEndPoint = (builder: ApiEndpointBuilder) => {
  return builder.query<DataResponse<ContractProjectDetails>, SearchRequest>({
    query: request => {
      return {
        url: `/contracts/projects/search`,
        method: "POST",
        body: request,
      };
    },
    serializeQueryArgs: ({ endpointName }) => {
      return endpointName;
    },

    async onQueryStarted(_arg, api) {
      try {
        const { data } = await api.queryFulfilled;
        if (data) {
          api.updateCachedData(draft => {
            return { ...draft };
          });
        }
      } catch (err) {
        console.error(err);
      }
    },

    forceRefetch({ currentArg, previousArg }) {
      return currentArg !== previousArg;
    },

    // merge current cache with new data
    merge: (currentCache, newData) => {
      const cachePage = currentCache?.currentPage || 0;
      if (currentCache.data && newData?.currentPage && cachePage < +newData?.currentPage) {
        return {
          ...newData,
          data: [...currentCache.data, ...newData.data],
        };
      } else {
        return newData;
      }
    },
    providesTags: result => {
      return result?.data
        ? [
            ...result.data.map((item: ContractProjectDetails) => ({
              type: "Project",
              id: item.id,
            })),
            { type: "ProjectList" },
          ]
        : [{ type: "ProjectList" }];
    },
  });
};

export default searchInfiniteProjectsEndPoint;
